/* istanbul ignore file */
import Card from './Card';

export default Card;
